import { ref } from 'vue';

import { publicOfferLib } from '../lib';
import type { seo } from '../../..';

export const usePublicOffer = (
  getPublicOffer: () => Promise<seo.types.SeoPageQueryData>,
) => {
  const offer = ref<seo.types.SeoPageContent>();
  const isLoading = ref<boolean>(false);

  const fetchPublicOffer = () => {
    if (!offer.value) {
      isLoading.value = true;
      getPublicOffer()
        .then(data => {
          offer.value = publicOfferLib.getLocalizedPublicOffer(data.contents);
        })
        .finally(() => (isLoading.value = false));
    }
  };

  return {
    offer,
    fetchPublicOffer,
    isLoading,
  };
};
